if (!customElements.get('announcement-bar')) {

    class AnnouncementBar extends HTMLElement {
        constructor() {
            super();

            this.content = this.firstElementChild || this; // Get inner text container or self
            
            this.init(); 
        }
    
        init() {
            if (this.content.getBoundingClientRect().width > document.documentElement.clientWidth) {
            this.classList.add('__marquee');
            }
        }
    }

    customElements.define('announcement-bar', AnnouncementBar);
}